module.exports = __webpack_public_path__ + "img/c18.e501aaf6.png";